<template>
	<div class="indexView">
		<el-container>
			<el-main>
				<HeaderRow selUrl=""></HeaderRow>
				<div class="breadcrumb">
					<div class="backItem" @click="()=>$router.back()"><i class="el-icon-arrow-left">返回</i></div>
					<el-breadcrumb separator="/">
						<el-breadcrumb-item to="/">首页</el-breadcrumb-item>
						<el-breadcrumb-item to="/myCourse">我的课程</el-breadcrumb-item>
					</el-breadcrumb>
				</div>
				<div class="content">
					<div class="leftMenu">
						<p @click="toMyPage('myOrder')">
							<i class="el-icon-s-unfold"></i> 我的订单
						</p>
						<p class="sel">
							<i class="el-icon-menu"></i> 我的课程
						</p>
						<p @click="toMyPage('myCollect')">
							<i class="el-icon-star-on"></i> 我的收藏
						</p>
						<p @click="toMyPage('myPartner')">
							<i class="el-icon-s-custom"></i> 我的团队
						</p>
					</div>
					<div class="rightList">
						<div class="status">
							<div class="status statusSel">
								<span>全部课程</span>
								<span />
							</div>
						</div>
						<div class="list" v-if="specialList&&specialList.length">
							<el-collapse ref="accordion" accordion v-model="accordionVal" @change="onSpecChange">
								<el-collapse-item v-for="spec in specialList" :key="spec.special_id" :name="spec.special_id">
									<template v-slot:title>
										<div class="specItem">
											<img :src="spec.image"></img>
											<div class="right">
												<p>{{spec.name||'名称'}}</p>
												<p>{{spec.remark||'简介'}}</p>
												<span>{{accordionVal==spec.special_id?"收起":"展开"}}</span>
											</div>
										</div>
									</template>
									<div class="specContent" v-if="courseList&&courseList.length">
										<div class="item" v-for="course in courseList" :key="course.course_id">
											<div class="info">
												<div class="pro">
													<img :src="course.thumb_image"></img>
													<div class="right">
														<span>{{course.title||'名称'}}</span>
														<span>{{course.description||'简介'}}</span>
													</div>
												</div>
												<div class="action">
													<span>{{course.purchase_date}}</span>
													<button size="default" type="default" @click="toCourseDetail(course)">学习</button>
												</div>
											</div>
										</div>
									</div>
									<div v-else class="noData">
										<img src="@/assets/empty.jpg"></img>
										<span>无数据</span>
									</div>
								</el-collapse-item>

							</el-collapse>

						</div>
						<div v-else class="noData">
							<img src="@/assets/empty.jpg"></img>
							<span>无数据</span>
						</div>
					</div>
				</div>
				<FooterRow></FooterRow>
			</el-main>
		</el-container>
	</div>
</template>

<script>
	import indexjs from "./index.js";
	import {
		copy
	} from "clipboard";
	import HeaderRow from "@/components/headerRow.vue";
	import FooterRow from "@/components/footerRow.vue";

	export default {
		methods: {
			copy,
		},
		computed: {
			Price() {
				return (price, digit) => parseFloat(price).toFixed(digit || 0);
			},
		},
		...indexjs,
		components: {
			HeaderRow,
			FooterRow,
		},

	};
</script>

<style lang="scss" scoped>
	@import "./index.scss";
</style>